import { Component, OnInit, Input } from '@angular/core';
import { CompanyListItem } from '../../models/company-list.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-company-item',
  templateUrl: './company-item.component.html',
  styleUrls: ['./company-item.component.css'],
  host: { 'class': 'col-12 col-sm-6 col-md-4 col-lg-3' }
})
export class CompanyItemComponent implements OnInit {

  @Input()
  company: CompanyListItem;

  constructor(
    private router: Router
  ) { }

  get usageRate() {
    if (this.company.tarifMaxLifts === 0) {
      return 100;
    }

    return this.company.liftCount / (this.company.tarifMaxLifts * 0.01);
  }

  ngOnInit() {
    
  }

  goToDetail(id: number) {
    this.router.navigate([{ outlets: { modal: ['company-detail', id] } }]);
  }

}
